<template>
    <div class="row mt-4">

        <div class="col-md-12">
            <div class="card card-stats">
                <div class="card-body">
                    <div class="card-title text-center">
                        График платежей
                    </div>

                    <div class="card-subtitle">
                        <div class="row">
                            <div class="col-12">
                                <canvas id="payments-stats" height="60px"></canvas>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';


    export default {
        name: "AnalyticsGraphic",
        data() {
            return {
                chart: null
            }
        },
        computed: {
            filterType() {
                return this.$store.state.filterType;
            },
            paymentType() {
                return this.$store.state.filterPaymentType;
            },
            dateFrom() {
                return this.$store.state.filterDateFrom;
            },
            dateTo() {
                return this.$store.state.filterDateTo;
            },
            merchantId() {
                return this.$store.state.merchantId;
            },
            admin() {
                return this.$store.state.admin;
            }
        },
        watch: {
            filterType() {
                if (this.dateFrom != null) {
                    this.apiCall(this.dateFrom, this.dateTo);
                }
            },
            paymentType() {
                this.apiCall(this.dateFrom, this.dateTo);
            },
            merchantId() {
                this.apiCall(this.dateFrom, this.dateTo);
            }
        },
        mounted() {
            let paymentsChartContext = document.getElementById("payments-stats");

            this.chart = new Chart(paymentsChartContext, {
                type: 'line',
                data: {
                    datasets: [
                        {
                            backgroundColor: '#7DBE26',
                            label: "Успешные",
                            borderColor: "#7DBE26",
                            fill: false
                        },
                        {
                            backgroundColor: '#FF777A',
                            label: "Ошибочные",
                            borderColor: "#FF777A",
                            fill: false
                        },
                        {
                            backgroundColor: '#FFCC66',
                            label: "В ожидании",
                            borderColor: "#FFCC66",
                            fill: false
                        },
                        {
                            backgroundColor: '#268AFF',
                            label: "Возврат",
                            borderColor: "#268AFF",
                            fill: false
                        },
                        {
                            backgroundColor: '#000',
                            label: "Незавершенные",
                            borderColor: "#000",
                            fill: false
                        },
                        {
                            backgroundColor: '#8F8F8F',
                            label: "Отмененные",
                            borderColor: "#8F8F8F",
                            fill: false
                        },
                    ]
                },
                options: {
                    responsive: true,
                    hover: {
                        mode: 'nearest',
                        intersect: true
                    },
                    legend: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }
            });
            this.apiCall(this.dateFrom);
        },
        methods: {
            apiCall(dateFrom, dateTo) {
                this.$store.commit('setLoading');
                let params = {
                    'payment-type': this.paymentType,
                    'date-from': dateFrom,
                    'date-to': dateTo,
                };
                if (this.merchantId) {
                    params['merchant-id'] = this.merchantId;
                }

                axios.get('/admin/analytics/total-day-group', {
                    params: params
                }).then(response => {
                    let payments = response.data.data;

                    this.chart.data.labels = [];
                    this.chart.data.datasets[0].data = [];
                    this.chart.data.datasets[1].data = [];
                    this.chart.data.datasets[2].data = [];
                    this.chart.data.datasets[3].data = [];
                    this.chart.data.datasets[4].data = [];
                    this.chart.data.datasets[5].data = [];

                    if (dateFrom === dateTo) {
                        for (let hour = 0; hour < 24; ++hour) {
                            this.chart.data.labels.push(hour);
                            this.chart.data.datasets[0].data.push(0);
                            this.chart.data.datasets[1].data.push(0);
                            this.chart.data.datasets[2].data.push(0);
                            this.chart.data.datasets[3].data.push(0);
                            this.chart.data.datasets[4].data.push(0);
                            this.chart.data.datasets[5].data.push(0);
                        }

                        for (let i = 0; i < payments.length; ++i) {
                            let payment = payments[i];
                            switch (payment.extended_status) {
                                case 1: // success 1 успех [0]
                                    this.chart.data.datasets[0].data[payment.date] = parseInt(payment.cnt);
                                    break;
                                case 6: // failed 6  ошибочные [1]
                                    this.chart.data.datasets[1].data[payment.date] = (parseInt(payment.cnt));
                                    break;
                                case 7: // failed 7 таймаут [1]
                                    this.chart.data.datasets[4].data[payment.date] = (parseInt(payment.cnt));
                                    break;
                                case 2: // process 4 в ожидании [2]
                                    this.chart.data.datasets[2].data[payment.date] = parseInt(payment.cnt);
                                    break;
                                case 4: // cancelled
                                    this.chart.data.datasets[5].data[payment.date] = parseInt(payment.cnt);
                                    break;
                                case 5: // возврат
                                    this.chart.data.datasets[0].data[payment.date] += parseInt(payment.cnt);
                                    this.chart.data.datasets[3].data[payment.date] = parseInt(payment.cnt);
                                    break;
                            }
                        }

                    } else {
                        let newDateFrom = moment(this.dateFrom);
                        while (newDateFrom <= moment(this.dateTo)) {
                            this.chart.data.labels.push(newDateFrom.format("DD-MM-YYYY"));
                            this.chart.data.datasets[0].data.push(0);
                            this.chart.data.datasets[1].data.push(0);
                            this.chart.data.datasets[2].data.push(0);
                            this.chart.data.datasets[3].data.push(0);
                            this.chart.data.datasets[4].data.push(0);
                            this.chart.data.datasets[5].data.push(0);
                            newDateFrom = moment(newDateFrom).add(1, 'd');
                        }

                        for (let i = 0; i < payments.length; ++i) {
                            let payment = payments[i];

                            let index = this.chart.data.labels.findIndex(label => {
                                return label == moment(payment.date).format('DD-MM-YYYY');
                            });
                            switch (payment.extended_status) {
                                case 1:
                                    this.chart.data.datasets[0].data[index] = parseInt(payment.amount);
                                    break;
                                case 6:
                                    this.chart.data.datasets[1].data[index] = (parseInt(payment.amount));
                                    break;
                                case 2:
                                    this.chart.data.datasets[2].data[index] = parseInt(payment.amount);
                                    break;
                                case 4:
                                    this.chart.data.datasets[5].data[index] = parseInt(payment.amount);
                                    break;
                                case 7:
                                    this.chart.data.datasets[4].data[index] = (parseInt(payment.amount));
                                    break;
                                case 5: // cancelled 4 в возврат [2]
                                    this.chart.data.datasets[0].data[index] += (parseInt(payment.amount) - parseInt(payment.refund_amount))
                                    this.chart.data.datasets[3].data[index] = (parseInt(payment.refund_amount));
                                    break;
                            }
                        }
                    }

                    this.chart.update();
                    this.$store.commit('unsetLoading');
                })
                .catch(error => {
                    this.$store.commit('unsetLoading');
                })
            }
        }
    }
</script>

<style scoped>

</style>
